export default "__VITE_ASSET__BXOoA0C6__"